import { Link } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";
import { MessageSellerButton } from "@/components/chat/MessageSellerButton";

export const OrderPlaced = ({ method, convId }) => (
  <div data-testid="order-placed" className="bg-[#0F0F0F] text-white p-8 sm:p-10 fade-up">
    <CheckCircle2 className="h-10 w-10 text-[#C5A059] mb-6" strokeWidth={1.25} />
    <h2 className="font-display text-3xl mb-3">{method === "cod" ? "Order confirmed." : "Payment proof sent."}</h2>
    <p data-testid="order-placed-message" className="text-white/65 text-sm leading-relaxed max-w-md">
      {method === "cod"
        ? "The seller has been notified and will confirm your cash on delivery order soon."
        : "The seller will check your screenshot and confirm your order. You'll get a notification once it's confirmed."}
    </p>
    <div className="flex flex-wrap gap-3 mt-8">
      <Link to="/" data-testid="order-continue-shopping" className="inline-block border border-[#C5A059] text-[#C5A059] px-8 py-3 text-xs tracking-[0.3em] uppercase hover:bg-[#C5A059] hover:text-[#0F0F0F] transition-colors">
        Continue shopping
      </Link>
      <Link to="/orders" data-testid="order-view-orders" className="inline-block border border-white/30 text-white px-8 py-3 text-xs tracking-[0.3em] uppercase hover:border-[#C5A059] hover:text-[#C5A059] transition-colors">
        My orders
      </Link>
      {convId && <MessageSellerButton convId={convId} className="border border-white/30 text-white px-8 py-3 hover:border-[#C5A059] hover:text-[#C5A059]" />}
    </div>
  </div>
);
